import { Component } from '@angular/core';
var HTML_TEMPLATE = "<div class=\"od-spinner\"></div>";
var CSS_STYLE = "\n@keyframes rotate {\n\tfrom { transform: rotate(0deg);   }\n\tto   { transform: rotate(360deg); }\n}\n\n.od-spinner {\n\tanimation: rotate 1s linear infinite;\n\tbackground: #25aed8;\n\tborder-radius: 50%;\n\theight: 18px;\n\twidth: 18px;\n\tposition: relative;\n}\n\n.od-spinner:before,\n.od-spinner:after {\n\tcontent: '';\n\tposition: absolute;\n}\n\n.od-spinner:before {\n\tborder-radius: 50%;\n\tbackground:\n\t\t\tlinear-gradient(0deg,   hsla(0, 0%, 100%, 1  ) 50%, hsla(0, 0%, 100%, 0.9) 100%)   0%   0%,\n\t\t\tlinear-gradient(90deg,  hsla(0, 0%, 100%, 0.9)  0%, hsla(0, 0%, 100%, 0.6) 100%) 100%   0%,\n\t\t\tlinear-gradient(180deg, hsla(0, 0%, 100%, 0.6)  0%, hsla(0, 0%, 100%, 0.3) 100%) 100% 100%,\n\t\t\tlinear-gradient(360deg, hsla(0, 0%, 100%, 0.3)  0%, hsla(0, 0%, 100%, 0  ) 100%)   0% 100%\n;\n\tbackground-repeat: no-repeat;\n\tbackground-size: 50% 50%;\n\ttop: -1px;\n\tbottom: -1px;\n\tleft: -1px;\n\tright: -1px;\n}\n\n.od-spinner:after {\n\tbackground: white;\n\tborder-radius: 50%;\n\ttop: 10%;\n\tbottom: 10%;\n\tleft: 10%;\n\tright: 10%;\n}\n";
var Spinner = /** @class */ (function () {
    function Spinner() {
    }
    Spinner.decorators = [
        { type: Component, args: [{
                    selector: 'od-spinner',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    Spinner.ctorParameters = function () { return []; };
    return Spinner;
}());
export { Spinner };
//# sourceMappingURL=spinner.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-components/spinner/spinner.js
// module id = 421
// module chunks = 14